import React from 'react'
import { BookingImages } from '../BookingComponents/BookingImages';
import { BookingContent } from '../BookingComponents/BookingContent';
import { Link } from "react-router-dom";

export const BoookingPage = () =>  {
  return (
    <section className="BookingSectionarea">
      <div className="container">
      <div className='BookingSectionBackBtn'>
        <Link className='BookingSectionBackBtn' to="/Charters">
          <button>Back</button>
        </Link>
      </div>
        <div className="row">
            <div className="col-lg-6"><BookingImages/></div>
            <div className="col-lg-6"><BookingContent/></div>
        </div>
      </div>
    </section>
  )
}
